import React from 'react';
import { useIntl } from 'react-intl';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import EntryComponent from '../../../Components/ContactListWrapper/EntryComponent';
import {
  CAMPAIGN_ACCORDION_STYLES as styles,
  CAMPAIGN_COLUMNS,
} from '../Utils/constants';
import MassiveMessageEntry from './MassiveMessageEntry';

const CampaignAccordion = function CampaignAccordion({
  data = {},
  templateName = '',
  handleDeleteMassiveSMS = () => {},
  handleGoToMassiveAnalysis = () => {},
  toggleAccordion = () => {},
  expanded = null,
  isSupervisor = false,
}) {
  const intl = useIntl();
  const { id, name, scheduledOn, massiveSmses = [] } = data;

  return (
    <Accordion
      id={`${id}-accordion`}
      expanded={expanded === id}
      onChange={toggleAccordion(id)}
      disableGutters
      elevation={0}
      sx={styles.root}
      slotProps={{ transition: { unmountOnExit: true } }}
    >
      <AccordionSummary sx={styles.summary} expandIcon={<ExpandMoreIcon />}>
        <EntryComponent
          data={{ ...data, templateName }}
          columns={CAMPAIGN_COLUMNS}
          disableClickRow
          hideDivider
          rowSxCallback={() => styles.summaryRow}
          customStatusChipCallback={() => (
            <Button
              id="go-to-analysis"
              variant="outlined"
              disableElevation
              fullWidth
              startIcon={<BarChartRoundedIcon />}
              sx={{ textTransform: 'none' }}
              onClick={(e) => {
                e.stopPropagation(); //prevent accordion toggle
                handleGoToMassiveAnalysis(name);
              }}
            >
              {intl.messages.SENDS_ANALYSIS}
            </Button>
          )}
        />
      </AccordionSummary>
      <AccordionDetails sx={styles.details}>
        {massiveSmses.map((massive) => (
          <Paper
            key={massive?.massiveId}
            variant="outlined"
            sx={styles.sendPaper}
          >
            <MassiveMessageEntry
              scheduledOn={massive?.scheduledOn ?? scheduledOn}
              messageData={massive}
              campaignId={id}
              campaignName={name}
              isSupervisor={isSupervisor}
              handleDeleteMassiveSMS={handleDeleteMassiveSMS}
              handleGoToMassiveAnalysis={handleGoToMassiveAnalysis}
            />
          </Paper>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default CampaignAccordion;
